module.exports = __webpack_public_path__ + "img/lock-2.f31e7b5e.svg";